/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */

import React, { Component, Fragment, createRef } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { mixpanel, constants, getRandomId, TrapFocus } from 'common/helpers'
import cx from 'classnames'

import Overlay from 'components/layout/Overlay/Overlay'
import Center from 'components/layout/Center/Center'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Message from 'components/text/Message/Message'

import messages from './messages'
import s from './Modal.scss'

// TODO: Refactor that shite outta here
const getBooleanDataValueOrProp = (key, props) => {
  const prop = props[key]
  const dataProp = props.data ? props.data[key] : undefined

  if (typeof dataProp === 'boolean') {
    return dataProp
  }

  return prop
}

class Modal extends Component {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    initialFocusId: PropTypes.string,
    name: PropTypes.string.isRequired,
    title: PropTypes.any,
    titleNode: PropTypes.node,
    titleClassName: PropTypes.string,
    showCloseButton: PropTypes.bool,
    disableClose: PropTypes.bool,
    disableCloseOverlay: PropTypes.bool,
    withWhiteCloseButton: PropTypes.bool,
    withTransparentOverlay: PropTypes.bool,
    fullScreenOnMobile: PropTypes.bool,
    data: PropTypes.object,
    subText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    fullWidth: PropTypes.bool,
    titleUppercase: PropTypes.bool,
    onClose: PropTypes.func,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    data: {},
    showCloseButton: true,
    fullWidth: false,
    disableClose: false,
    disableCloseOverlay: false,
    uppercase: false,
    withWhiteCloseButton: false,
    withTransparentOverlay: false,
    fullScreenOnMobile: true,
    id: 'modal',
  }

  constructor(props) {
    super(props)

    this.modalContainerEl = createRef()
  }

  componentWillMount() {
    this.resolveEvents()
  }

  componentDidMount() {
    this.handleMount()
  }

  componentWillUnmount() {
    if (this.trapFocus) {
      this.trapFocus.unmount()
    }
  }

  handleMount = () => {
    const modalContainerEl = this.modalContainerEl.current

    if (modalContainerEl) {
      modalContainerEl.classList.add(s.mounted)

      const { name, initialFocusId } = this.props

      const trapFocusElement  = document.getElementById(`${name}_trapfocus`)
      let initialFocusElement = trapFocusElement

      if (initialFocusId) {
        initialFocusElement = document.getElementById(initialFocusId)
      }

      this.trapFocus = new TrapFocus(trapFocusElement, { withInitialFocus: false })

      if (initialFocusElement) {
        initialFocusElement.focus()
      }

      this.trapFocus.mount()
    }
  }

  resolveEvents() {
    const { data: { mixpanelEvent } } = this.props

    if (mixpanelEvent) {
      const { name, ...rest } = mixpanelEvent

      mixpanel.track(name, rest)
    }
  }

  close = (type) => {
    const { name, data, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose(type)
    }

    if (typeof data.onClose === 'function') {
      data.onClose(type)
    }
  }

  handleClickCloseButton = () => {
    const disableClose = getBooleanDataValueOrProp('disableClose', this.props)

    if (!disableClose) {
      this.close('close')
    }
  }

  render() {
    const {
      children, id, name, className, contentClassName,
      title, titleNode, titleClassName, subText,
      titleUppercase, fullWidth, onClick, fullScreenOnMobile, withWhiteCloseButton, withTransparentOverlay,
    } = this.props

    const trapFocusId = `${name}_trapfocus`

    const modalContainerClassName = cx(s.modalContainer, {
      [s.fullWidth]: fullWidth,
      [s.containerCenteredOnMobile]: !fullScreenOnMobile,
    })

    const modalClassName = cx(s.modal, className, {
      [s.centeredOnMobile]: !fullScreenOnMobile,
    })

    const modalTitleClassName = cx(s.title, titleClassName, 'modalTitle', {
      [s.uppercase]: titleUppercase,
    })

    const overlayClassName = cx({
      [s.noBg]: withTransparentOverlay,
    })

    const buttonClassName = cx(s.closeButton, {
      [s.whiteCloseButton]: withWhiteCloseButton,
    })

    const showCloseButton = getBooleanDataValueOrProp('showCloseButton', this.props)
    const disableClose    = getBooleanDataValueOrProp('disableClose', this.props)

    const isTitleExists = Boolean(title || titleNode)
    const titleId       = isTitleExists ? getRandomId('title') : undefined

    return (
      <Overlay className={overlayClassName} dataToggleOff={name}>
        <Center scrollable>
          <div
            className={modalContainerClassName}
            ref={this.modalContainerEl}
            onClick={(event) => event.stopPropagation()}
          >
            <div
              className={modalClassName}
              onClick={onClick}
              id={id}
              data-testid={constants.testIds.modal.root}
              role="dialog"
              aria-modal
              aria-labelledby={titleId}
            >
              <div
                id={trapFocusId}
                className={s.trapFocus}
                tabIndex={0}
              >
                {
                  isTitleExists && (
                    <div className={s.header}>
                      {
                        Boolean(titleNode) && (
                          React.cloneElement(titleNode, {
                            className: cx(modalTitleClassName, titleNode.props.className),
                            id: titleId,
                          })
                        )
                      }
                      {
                        !titleNode && (
                          <Message
                            id={titleId}
                            className={modalTitleClassName}
                            tag="div"
                            text={title}
                            html
                          />
                        )
                      }
                    </div>
                  )
                }
                <div className={cx(s.content, contentClassName)}>
                  <Fragment>
                    {children}
                  </Fragment>
                  {
                    subText && (
                      <Message className={s.subText} tag="div" text={subText} html />
                    )
                  }
                </div>
                {
                  showCloseButton && !disableClose && (
                    <CloseIcon
                      className={buttonClassName}
                      onClick={this.handleClickCloseButton}
                      whiteColor={withWhiteCloseButton}
                      dataTestId={constants.testIds.modal.closeIcon}
                      ariaLabel={messages.close}
                    />
                  )
                }
              </div>
            </div>
          </div>
        </Center>
      </Overlay>
    )
  }
}

export default Modal
